module.exports = __webpack_public_path__ + "documents/webhooks/v2/alert_notification.yml";